<template>
  <div>
    <v-card :class="mobile ? 'pa-0' : 'pa-5'" v-if="word_detail">
      <v-card-title primary-title :class="mobile ? 'pl-2' : 'pl-5'">
        <h1>“{{ word_detail ? word_detail.mean : " - " }}”</h1>
      </v-card-title>
      <v-card-text v-if="found_sub_language">
        <v-row justify="center" align="start">
          <v-col cols="12" justify="center" align="start">
            <!-- <v-list> -->
            <v-list-item
              two-line
              v-for="(item, index) in word_detail.subLanguage"
              :key="index"
              v-show="
                languageBtn == 'all' ? true : languageBtn == item.languageId
              "
            >
              <v-list-item-avatar tile>
                <span v-for="(img, index) in languageList" :key="index">
                  <v-img
                    width="48"
                    v-if="item.languageId == img.languageId"
                    :src="require('@/assets/flag/' + img.languagePathImg)"
                  ></v-img>
                </span>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title
                  v-for="(name, index) in languageList"
                  :key="index"
                  v-show="item.languageId == name.languageId"
                >
                  <font class="text_body_3 ml-2" color="#0c57d2">{{
                    WEB_LANGUAGE == "th"
                      ? name.languageName
                      : WEB_LANGUAGE == "en"
                      ? name.languageNameEn
                      : "-"
                  }}</font>
                </v-list-item-title>
                <span class="text_body_5 grey--text pl-2"
                  >{{ item.alphabet }} (
                  {{
                    WEB_LANGUAGE == "th"
                      ? text.transcription.th
                      : WEB_LANGUAGE == "en"
                      ? text.transcription.en
                      : "-"
                  }}
                  {{ item.transcription }} )</span
                ><span
                  class="text_body_7 grey--text pl-2"
                  style="font-style: italic"
                  >{{
                    WEB_LANGUAGE == "th"
                      ? text.updated_on.th
                      : WEB_LANGUAGE == "en"
                      ? text.updated_on.en
                      : "-"
                  }}
                  {{ dateFormat(item.updatedAt) }}</span
                >
              </v-list-item-content>
            </v-list-item>
            <!-- </v-list> -->
          </v-col>
        </v-row>
        <v-row justify="center" align="start">
          <v-col cols="12" justify="center" align="start" class="py-0">
            <v-list-item>
              <v-list-item-avatar tile size="48" v-if="!mobile">
              </v-list-item-avatar>
              <v-list-item-content>
                <span class="text_title_5"
                  ><font color="#aeaeae">{{
                    WEB_LANGUAGE == "th"
                      ? text.category.th
                      : WEB_LANGUAGE == "en"
                      ? text.category.en
                      : "-"
                  }}</font>
                  <font class="ml-5">{{
                    category ? category.categoryName : " - "
                  }}</font></span
                >
              </v-list-item-content>
            </v-list-item>
          </v-col>
        </v-row>
        <!-- <pre>{{word_detail}}</pre> -->
      </v-card-text>
      <v-card-text v-else>
        <v-row align="center" justify="center">
          <v-col cols="10" align="center" justify="center">
            <font class="text_title_4">{{
              WEB_LANGUAGE == "th"
                ? text.sub_language_not_found.th
                : WEB_LANGUAGE == "en"
                ? text.sub_language_not_found.en
                : "-"
            }}</font>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import flag from "@/views/AppBehide/Settings/LanguageList.js";
import { bus } from "@/main";
import { text_searchHomePage } from "@/assets/javascript/dataLanguage.js";
export default {
  data() {
    return {
      WEB_LANGUAGE: "th",
      text: null,
      header_token: {
        headers: {
          token: "token_inet_dev",
        },
      },
      // master data
      languageList: [],
      categoryList: [],
      languageBtn: "all",
      word_detail: null,
      category: null,
      found_sub_language: true,
    };
  },
  computed: {
    mobile() {
      if (
        this.$vuetify.breakpoint.width >= 320 &&
        this.$vuetify.breakpoint.width < 768
      ) {
        return true;
      } else {
        return false;
      }
    },
    tablet() {
      if (
        this.$vuetify.breakpoint.width >= 768 &&
        this.$vuetify.breakpoint.width < 1440
      ) {
        return true;
      } else {
        return false;
      }
    },
    desktop() {
      if (this.$vuetify.breakpoint.width >= 1440) {
        return true;
      } else {
        return false;
      }
    },
  },
  created() {
    // this.getLanguage();
    // this.getCategory();
    this.text = text_searchHomePage;
    bus.$on("switchLanguage", (data) => {
      this.WEB_LANGUAGE = data;
    });
  },
  beforeDestroy() {
    bus.$off("switchLanguage");
  },
  methods: {
    setWordDetail(word) {
      this.loading = true;
      // console.log(word);
      this.word_detail = word;
      this.categoryList.forEach((element) => {
        if (this.word_detail.categoryId == element.categoryId) {
          this.category = element;
          // console.log(this.category);
        }
      });
      if (this.word_detail.subLanguage.length > 0) {
        this.word_detail.subLanguage.forEach((sub) => {
          if (this.languageBtn == "all") {
            this.found_sub_language = true;
          } else if (this.languageBtn == sub.languageId) {
            this.found_sub_language = true;
          }
        });
      } else {
        this.found_sub_language = false;
      }
    },
    getLanguage(data) {
      // this.axios
      //   .get(
      //     process.env.VUE_APP_API + "api/v1/masterdata/language",
      //     this.header_token
      //   )
      //   .then(response => {
      //     // console.log(response.data);
      //     this.languageList = response.data;
      //   })
      //   .catch(err => {
      //     console.log("api get categoty detail err");
      //   });
      this.languageList = data;
    },
    getCategory(data) {
      // this.axios
      //   .get(
      //     process.env.VUE_APP_API + "api/v1/masterdata/category",
      //     this.header_token
      //   )
      //   .then(response => {
      //     // console.log(response.data);
      //     this.categoryList = response.data;
      //     this.loading = false;
      //   })
      //   .catch(err => {
      //     console.log("api get categoty detail err");
      //   });
      this.categoryList = data;
    },
    setLanguageBtn(language) {
      this.languageBtn = language;
      // console.log(language);
      this.languageFilter();
    },
    languageFilter() {
      this.found_sub_language = false;
      if (this.word_detail) {
        if (this.word_detail.subLanguage.length > 0) {
          this.word_detail.subLanguage.forEach((sub) => {
            if (this.languageBtn == "all") {
              this.found_sub_language = true;
            } else if (this.languageBtn == sub.languageId) {
              this.found_sub_language = true;
            }
          });
        } else {
          this.found_sub_language = false;
        }
      } else {
        this.found_sub_language = false;
      }
    },
    dateFormat(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      if (this.WEB_LANGUAGE == "th") {
        let year_th = parseInt(year) + 543;
        switch (month) {
          case "1":
            return day + " ม.ค. " + year_th;
          case "2":
            return day + " ก.พ. " + year_th;
          case "3":
            return day + " มี.ค. " + year_th;
          case "4":
            return day + " เม.ย. " + year_th;
          case "5":
            return day + " พ.ค. " + year_th;
          case "6":
            return day + " มิ.ย. " + year_th;
          case "7":
            return day + " ก.ค. " + year_th;
          case "8":
            return day + " ส.ค. " + year_th;
          case "9":
            return day + " ก.ย. " + year_th;
          case "10":
            return day + " ต.ค. " + year_th;
          case "11":
            return day + " พ.ย. " + year_th;
          case "12":
            return day + " ธ.ค. " + year_th;
          default:
            return " - ";
            break;
        }
      } else {
        switch (month) {
          case "1":
            return day + " Jan. " + year;
          case "2":
            return day + " Feb. " + year;
          case "3":
            return day + " Mar. " + year;
          case "4":
            return day + " Apr. " + year;
          case "5":
            return day + " May. " + year;
          case "6":
            return day + " Jun. " + year;
          case "7":
            return day + " Jul. " + year;
          case "8":
            return day + " Aug. " + year;
          case "9":
            return day + " Sep. " + year;
          case "10":
            return day + " Oct. " + year;
          case "11":
            return day + " Nov. " + year;
          case "12":
            return day + " Dec. " + year;
          default:
            return " - ";
            break;
        }
      }
    },
  },
};
</script>
